import styled from 'styled-components'
import theme from 'theme_'

export const NetworkGraphController = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${theme.spacing.base};
  margin-top: 5%;
  margin-left: 1%;
  margin-right: 1%;
  width: 98%;
  height: fit-content;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`

export const NetworkGraphButtonsControlsFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 0px 20px 0px;

  width: 100%;
  height: 32px;

  border-radius: 20px;

  flex: none;
  order: 1;
  flex-grow: 1;
`

export const NetworkGraphButton = styled.div<{
  selected?: boolean
}>`
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 12px;
  gap: 10px;

  width: 25%;
  height: 32px;

  opacity: 0.7;
  border-radius: 0px;

  flex: none;
  order: 1;
  flex-grow: 1;

  background: ${(p) =>
    p.selected ? theme.colors.hover10 : theme.colors.white};
  color: ${(p) =>
    p.selected ? theme.colors.horizonOrange : theme.colors.anotherDarkGrey};
  border: ${(p) =>
    p.selected
      ? '1px solid' + theme.colors.horizonOrange
      : '1px solid #dbd9d6'};

  :hover {
    background-color: ${theme.overlay.newMenuHover};
    backdrop-filter: ${theme.overlay.SBlur};
  }

  :disabled {
    background-color: ${theme.colors.lightGrey};
  }
`
